module.exports = __webpack_public_path__ + "img/savingnotes-es.16e50bb4.png";